import { Box, Grid2 as Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { CONTEST_API } from '../../api/endpoint';
import { ContestDetail } from '../../types';
import ContestDetailDialog from './detail-component';
import Loader from '../../components/loader';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import TimelineButtons from '../champs/timeline-buttons';
import createAxiosInstance from '../../api/axiosConfig';
import style from './style.module.css';
import TopQuest from '../home/top-quest';

const Contests = () => {
  const [timeline, setTimeline] = useState('completed');
  const [data, setData] = useState<any[]>([]);
  const [selectedContest, setSelectedContest] = useState<any | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();

  const handleTimelineChange = (newTimeline: string) => {
    if (newTimeline !== timeline) {
      setTimeline(newTimeline);
    }
  };

  const items = ['ongoing', 'completed', 'upcoming'];
  const pageToken = '';
  const count = 10;
  const location = useLocation();
  const contestPage = location.pathname === '/contests';

  const fetchContest = async (pageToken: string, count: number) => {
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(true);
      const response = await axiosInstance.get(`${CONTEST_API}/${timeline}.json`, {});
      setData(response.data.data);
    } catch (error) {
      console.error('Error fetching contests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContest(pageToken, count);
  }, [timeline]);

  const openDialog = (contest: any) => {
    setSelectedContest(contest);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setSelectedContest(null);
  };

  const handleResults = (contest: ContestDetail) => {
    navigate(`/contest/${contest?.contest_id}`, {
      state: { contest, timeline }
    });
  };

  const SingleCard = ({
    contestId,
    filename,
    title,
    desc,
    ageLimit,
    date,
    item,
    from,
    to
  }: {
    contestId: string;
    filename: string;
    title: String;
    desc: [];
    ageLimit: String;
    date: any;
    item: ContestDetail;
    from: any;
    to: string;
  }) => {
    const description = desc;
    return (
      <Box className={style.cardView} onClick={() => handleResults(item)} style={{ cursor: 'pointer' }}>
        <Box className={style.bannerimg}>
          <img
            alt={'banner'}
            src={`${process.env.REACT_APP_DEFAULT_AVATAR}/CONTESTS/${contestId}/IMAGES/medium/${filename}`}
          />
        </Box>
        <Box className={style.bannerimg}>
          <img
            alt={'banner'}
            src={`${process.env.REACT_APP_DEFAULT_AVATAR}/CONTESTS/${contestId}/IMAGES/medium/${filename}`}
          />
        </Box>

        <Box className={style.blurrr}>
          <Typography sx={{ padding: '5px', fontSize: '20px', fontFamily: 'Baloo2', fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography
            className={style.desc}
            sx={{
              padding: '3px',
              fontSize: '14px',
              fontFamily: 'Baloo2',
              opacity: '0.7'
            }}>
            {description}
          </Typography>
          <Typography
            sx={{
              padding: '2px',
              fontSize: '14px',
              fontFamily: 'Baloo2',
              opacity: '0.7'
            }}>{`Age Limit: ${ageLimit}`}</Typography>
          <Box sx={{ padding: '10px' }} className={'contest_btn'} onClick={() => handleResults(item)}>
            <Typography sx={{ fontSize: '17px', fontFamily: 'Baloo2' }}>View Results</Typography>
          </Box>
        </Box>
        <Box className={style.overlayblur}>
          <Typography
            sx={{
              textAlign: 'center',
              color: 'white',
              fontSize: '12px',
              fontWeight: '200',
              fontFamily: 'Baloo2'
            }}>
            {timeline === 'completed' ? `ends at ${to}` : `Starts in ${from}`}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Box>
        <TopQuest />
      </Box>
      <Typography
        sx={{
          color: 'white',
          letterSpacing: isMobile ? 1 : 3,
          marginBottom: isMobile ? 2 : 5,
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '24px' : '48px',
          fontWeight: 800,
          paddingLeft: '35px',
          textAlign: !isMobile ? 'center' : 'none'
        }}>
        Contests
      </Typography>
      <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
        <TimelineButtons
          page={'contest'}
          items={items}
          timeline={timeline}
          handleTimelineChange={handleTimelineChange}
        />
      </Grid>
      {loading && <Loader />}

      {!loading && data.length !== 0 ? (
        <Box className={style.cardContainer}>
          {data.map((item: any, index: number) => (
            <SingleCard
              key={index}
              contestId={item.contest_id}
              filename={item.cr_banner}
              title={item.title}
              desc={item.description}
              ageLimit={item.age_limit}
              date={item.from}
              item={item}
              from={item.from.split('T')[0]}
              to={item.to.split('T')[0]}
            />
          ))}
        </Box>
      ) : (
        !loading && (
          <Box sx={{ textAlign: 'center', padding: '50px' }}>
            <Typography>
              {timeline === 'ongoing'
                ? 'No Ongoing contests'
                : timeline === 'upcoming'
                  ? 'No Upcoming contests'
                  : 'No contest completed'}
            </Typography>
          </Box>
        )
      )}
    </>
  );
};

export default Contests;
